<template>
  <div class="container">
    <div class="card">
      <div class="card-body" v-dynamic-content:iquote_not_found_error_text></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageError',
}
</script>
